import React from "react"
import { useSelector } from "react-redux"
import { getSubsidyStatus } from "reducers/subsidyStatus"
import { Spacer } from "../atoms/Atoms"
import L10n from "../../../lib/carrot-l10n"
import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import { RRButtonFooter } from "../atoms/roundedrectangle/RRButtonFooter"
import {
  getIsBenefitLifetimeOnly,
  getPercentageOfLifetimeBenefitClaimed,
  getPercentageOfYearlyBenefitClaimed
} from "derivedSelectors"
import { getCurrencySymbol } from "reducers/companyInfo"
import { Thermometer } from "./Thermometer"
import { CurrencyString } from "components/views/molecules/CurrencyString"
import { PlanInfoBadgeContainer } from "components/containers/planinfo/PlanInfoBadgeContainer"
import { H2Library, H4 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const AvailableBenefitModule = ({ id }) => {
  const isBenefitLifetimeOnly = useSelector(getIsBenefitLifetimeOnly)
  const currencySymbol = useSelector(getCurrencySymbol)
  const percentageOfYearlyBenefitClaimed = useSelector(getPercentageOfYearlyBenefitClaimed)
  const percentageOfLifetimeBenefitClaimed = useSelector(getPercentageOfLifetimeBenefitClaimed)
  const { yearlyMax, yearlyAvailable, yearlyClaimed, lifetimeClaimed } = useSelector(getSubsidyStatus)

  const thermometerBars = [
    {
      label: l`used`,
      color: "dark-mint",
      value: isBenefitLifetimeOnly ? lifetimeClaimed : yearlyClaimed,
      percentage: isBenefitLifetimeOnly ? percentageOfLifetimeBenefitClaimed : percentageOfYearlyBenefitClaimed
    }
  ]

  return (
    <RoundedRectangle id={id} backgroundColor="mint-alternate">
      <H4 stack="tiny">{l`client.reimbursements.yourBalance`}</H4>
      <Spacer height={0.5} />
      <H2Library>
        <CurrencyString amount={Math.max(yearlyAvailable, 0)} />
      </H2Library>
      <Spacer height={0.5} />
      <Thermometer
        barBackgroundColor="carrot-medium-green"
        minValue={0}
        maxValue={yearlyMax}
        bars={thermometerBars}
        currencySymbol={currencySymbol}
      />
      <Spacer height={1} />
      <PlanInfoBadgeContainer backgroundColor="white-50" fontColor="black-80" />
      <RRButtonFooter outline to="/transactions">
        <span className="nowrap">{l`client.moreDetails`}</span>
      </RRButtonFooter>
    </RoundedRectangle>
  )
}

export default AvailableBenefitModule
